import supabase from "./supabase";
import { FunctionsHttpError } from "@supabase/supabase-js";

export async function deleteAdmin(
  adminId: string
): Promise<{ error: string | null }> {
  const { error } = await supabase.functions.invoke("deleteAdmin", {
    body: {
      adminId,
    },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();
    return { error: errorMessage.error };
  }

  return { error: error?.message || null };
}
